import MarkdownIt from "markdown-it";
import Mila from "markdown-it-link-attributes";
import { html5Media } from "markdown-it-html5-media";

// 配置 markdown 解析器（与 Editor.js 保持一致），供 SmartContent 以及需要
// 按 markdown 渲染的后端录入内容（如系统通知）复用。
const mdParser = new MarkdownIt({
  linkify: true,
  breaks: true,
}).use(require("markdown-it-replace-link"), {
  processHTML: true,
  replaceLink: function (link, env, token, htmlToken) {
    let newLink = link;
    if (!link.startsWith("https://") && !link.startsWith("http://")) {
      newLink = `http://${link}`;
    }
    return newLink;
  },
});

mdParser.use(html5Media);

mdParser.use(Mila, [
  {
    matcher(href, config) {
      return href.startsWith("/") || href.includes("eleduck.com");
    },
    attrs: {
      target: "_blank",
      rel: "noopener",
    },
  },
  {
    matcher(href, config) {
      return !href.startsWith("/") && !href.includes("eleduck.com");
    },
    attrs: {
      target: "_blank",
      rel: "noopener nofollow",
    },
  },
]);

export const renderMarkdown = (text) => mdParser.render(text || "");

export default mdParser;
